<template>
  <v-app>
    <v-main  class="pt-0">

      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; " :flat='true'>
        <div v-if="!loading && (reg_count == 0)">
          <p v-if="can_reg && !wait_reg" style="color: red; font-size: 16px;"><b>Вы еще НЕ зарегистрированы на Форум. Нажмите на кнопку ниже</b></p>
          <p v-if="!can_reg" style="color: red; font-size: 16px;"><b>Вы НЕ зарегистрированы на Форум. Регистрация уже завершена</b></p>
          <p v-if="wait_reg" style="color: red; font-size: 16px;"><b>Регистрация на форум еще не открыта</b></p>
        </div>

        <div v-if="reg_count > 0">
          <div class="date-interval d-flex">
            <p style="color: green; font-size: 16px; margin-top:16px; margin-right: 10px;"><b>Вы зарегистрированы на Форум</b></p>
          </div>

          <!-- <p v-if="user_registrations[0].confirm_tour == 2" style="margin-bottom: 0px; font-size: 16px;"><b>Участник экскурсии в НИЦ "КИ":</b><b style="color: green;"> Да </b></p>
          <p v-else style="margin-bottom: 0px; font-size: 16px;"><b>Участник экскурсии в НИЦ "КИ":</b> <b style="color: red;">Нет </b></p> -->
          
          
          <div v-if="reg_count < 3 && can_reg">
            <v-chip
              class="mr-2 ml-2 mt-2"
              dark
              outlined
              label
              style="margin-bottom:20px;"
              @click="add_reg_dialog = true"
              color="#ff810a">
              <v-icon left>mdi-plus</v-icon>
              Добавить выступление
            </v-chip>
          </div>

          <!--  -->
          <div v-for="reg_record in user_registrations" :key="reg_record.id">
            <v-card  class="main-container pa-3">
              
              <div v-if="reg_record.confirm_type > 0">
                <div class="d-flex">
                  <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Подтвержденный формат участия: </b> {{ reg_record.confirm_type == 1 ? 'Слушатель' : (reg_record.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом') }}</p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="cancel_reg_dialog = true, reg_id = reg_record.id">
                        mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <span>отменить регистрацию</span>
                  </v-tooltip>
                </div>
                <div v-if="reg_record.confirm_type > 1">
                  <p style="font-size: 16px;  margin-right: 30px;"><b>Дата выступления: </b> {{ (reg_record.org_comment && reg_record.org_comment.length > 0) ? reg_record.org_comment : 'нет информации'}}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(reg_record.section_confirm_id) }}</p>
                  <p style="font-size: 16px;"><b>Название доклада: </b> {{ reg_record.comments.length > 0 ? reg_record.comments : 'Не указано при регистрации!'}}</p>
                </div>
              </div>
              <div v-else>
                <div class="d-flex">
                  <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Формат участия: </b> {{ reg_record.type == 1 ? 'Слушатель' : (reg_record.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом') }}</p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="cancel_reg_dialog = true, reg_id = reg_record.id">
                        mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <span>отменить регистрацию</span>
                  </v-tooltip>
                  <br>
                </div>
                <div v-if="reg_record.type > 1">
                  <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 16px;"> ожидайте подтверждения участия модератором </p>
                  <p style="margin-bottom: 0px; font-size: 16px;" ><b>Секция: </b> {{ section_descr(reg_record.section_choice_id) }}</p>
                  <p style="font-size: 16px;"><b>Название доклада: </b> {{ reg_record.comments.length > 0 ? reg_record.comments : 'Не указано при регистрации!'}}</p>
                </div>
              </div>


              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.is_confirm == false && reg_record.confirm_type > 1">
              <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.is_confirm == false && !can_reg && reg_record.confirm_type > 1"> -->
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, show_confirm_reg_dialog()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                    Подтвердить участие в Курчатовском геномном форуме
                </v-chip>
              </div>

              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.confirm_type == 1 || (reg_record.confirm_type > 1 && reg_record.is_confirm == true)">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_invite()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Скачать приглашение
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="(reg_record.confirm_type == 1 || (reg_record.confirm_type > 1 && reg_record.is_confirm == true)) && can_make_sert">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_sert()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Скачать сертификат
                </v-chip>
              </div>

          
              <div class="date-interval d-flex">
                <p v-if="reg_record.is_confirm == true" style="color: green; font-size: 16px; margin-top:0px; margin-right: 10px;"><b>Вы подтвердили участие в Форуме</b></p>
              </div>

              <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && reg_record && reg_record.type > 1 && !reg_record.file_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_thesis_dialog = true"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы
                </v-chip>
              </div> -->

              <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_upload_thesis && reg_record && !reg_record.thesis_id && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1))">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="current_user_registration_id = reg_record.id; upload_thesis_dialog = true"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы
                </v-chip>
              </div>
              <div class="content-personal__header d-flex align-start" v-if="reg_record && reg_record.thesis_id > 0">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="show_thesis(reg_record.thesis_id)"
                  color="#4dbee1">
                  <v-icon left>mdi-file-check-outline</v-icon>
                  Мои тезисы
                </v-chip>
                <v-tooltip right  v-if="can_upload_thesis">
                  <template v-slot:activator="{ on, attrs }" class="pt-3">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="delete_thesis(reg_record.thesis_id, reg_record.id)">
                        mdi-close-circle-outline
                      </v-icon>
                  </template>
                  <span>удалить тезисы</span>
                </v-tooltip>

                <!-- <v-btn left @click="delete_thesis(reg_record.thesis_id, reg_record.id)" icon>
                  <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                </v-btn> -->

              </div>

              <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.file_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'thesis_file', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы *.doc
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.file_pdf_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'thesis_pdf', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы *.pdf
                </v-chip>
              </div> -->
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.exp_file_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'exp_file', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить экспертное заключение
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record && (reg_record.file_id > 0 || reg_record.file_pdf_id > 0 || reg_record.exp_file_id > 0) && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1))">
                <v-list subheader>
                  <v-list-item v-if="reg_record.file_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Тезисы *.doc'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ reg_record.file }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn left @click="openFile(reg_record.file)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="can_reg">
                      <v-btn left @click="deleteFile(reg_record.id, 'del_thesis_doc')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="reg_record.file_pdf_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Тезисы *.pdf'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ reg_record.file_pdf }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="openFile(reg_record.file_pdf)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="can_reg">
                      <v-btn @click="deleteFile(reg_record.id, 'del_thesis_pdf')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="reg_record.exp_file_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Экспертное заключение'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ reg_record.exp_file }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="openFile(reg_record.exp_file)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="can_reg">
                      <v-btn @click="deleteFile(reg_record.id, 'del_exp_file')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

              </div>

              <div v-if="reg_record.confirm_type > 0">
                  <p style="font-size: 16px;  margin-right: 30px;"><b>Планирую участвовать в качестве слушателя: </b></p>
                  <p v-for="rec in selected_listen_sections" style="font-size: 16px;  margin-left: 30px;">  {{ ' - ' }} {{ section_descr(rec) }}</p>
              </div>
            </v-card>
          </div>
          <!--  -->

          
          



        </div>


        <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && !wait_reg && !loading && (reg_count == 0)">
          <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="margin-bottom:20px;"
            @click="registration_dialog = true"
            color="#ff810a">
            <v-icon left>mdi-check-decagram</v-icon>
              Зарегистрироваться на Курчатовский геномный форум
          </v-chip>
        </div>


        <personal-data-base/>

      </v-card>
    </v-main>

    <v-dialog v-model="add_reg_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Зарегистрировать дополнительное выступление
        </v-card-title>

        <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="user_type"
              :items="user_types"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <v-text-field
            v-model="dialog_comment"
            outlined
            required
            name="input-7-4"
            label="Название доклада"
          ></v-text-field>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="section_choice"
              :items="active_sections"
              item-text="name"
              item-value="id"
              outlined
              chips
              label="Выберите секцию"
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="add_one_reg()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registration_dialog" persistent max-width="65%">
      <v-card>
        <v-card-title class="headline">Зарегистрироваться на мероприятие
        </v-card-title>
        <!-- <v-card-text>Формат участия 
        </v-card-text> -->

        <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="user_type"
              :items="user_types"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <v-text-field
            v-model="dialog_comment"
            outlined
            required
            name="input-7-4"
            label="Название доклада"
          ></v-text-field>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="section_choice"
              :items="active_sections"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
              label="Выберите секцию"
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text>
          <p>На каких мероприятиях форума вы планируете присутствовать в качестве слушателя?</p>

          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>1 день (21 октября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 1 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.name"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>2 день (22 октября)</p>
            </v-col>
            <v-col cols="8">
              <div v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 2 && section.is_active" :key="section.id">
                <v-checkbox 
                  :disabled="!section.is_public"
                  v-model="selected_listen_sections"
                  :value="section.id"
                  style="margin-top: 0px !important; margin-left: 8px !important;"
                  :label="section.name"
                ></v-checkbox>
                <!-- <v-card-text v-if="need_proj_name"> -->
                  <v-text-field v-if="need_proj_name && section.id == session_young_id"
                    v-model="project_name"
                    outlined
                    required
                    name="input"
                    label="Название проекта"
                    class="pl-10"
                  ></v-text-field>
                <!-- </v-card-text> -->

              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_reg_dialog" persistent max-width="55%">
      <v-card>
        <v-card-title class="headline">Подтвердить участие в форуме
        </v-card-title>

        <v-card-text v-if="user_registrations_list[reg_id]">
          <div v-if="user_registrations_list[reg_id].confirm_type > 1">
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Предлагаемый формат участия: </b> {{ user_registrations_list[reg_id].confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата выступления: </b> {{ (user_registrations_list[reg_id].org_comment && user_registrations_list[reg_id].org_comment.length > 0) ? user_registrations_list[reg_id].org_comment : 'нет информации'}}</p>
          </div>
          <div v-else>
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_registrations_list[reg_id].type == 1 ? 'Слушатель' : (user_registrations_list[reg_id].type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p>
          </div>

          <!-- <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_registrations_list[reg_id].type == 1 ? 'Слушатель' : (user_registrations_list[reg_id].type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p> -->
          <p style="margin-bottom: 0px; font-size: 16px;" v-if="user_registrations_list[reg_id].type > 1"><b>Секция: </b> {{ section_descr(user_registrations_list[reg_id].section_confirm_id) }}</p>
          <p style="margin-bottom: 0px; font-size: 16px;" v-if="user_registrations_list[reg_id].type > 1"><b>Название доклада: </b> {{ user_registrations_list[reg_id].comments.length > 0 ? user_registrations_list[reg_id].comments : 'Не указано при регистрации!'}}</p>
          <!-- <p style="font-size: 14px; text-align: right; font-style: italic;"> * в случае ошибки в формате участия свяжитесь с организаторами форума</p> -->
        </v-card-text>

        <v-card-text v-if="user_registrations_list[reg_id] && user_registrations_list[reg_id].confirm_type == 3">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="current_confirm_type"
              :items="user_types_poster"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text>
          <p>На каких мероприятиях форума вы планируете присутствовать в качестве слушателя?</p>

          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>1 день (21 октября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 1 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.name"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>2 день (22 октября)</p>
            </v-col>
            <v-col cols="8">
              <div v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 2 && section.is_active" :key="section.id">
                <v-checkbox 
                  :disabled="!section.is_public"
                  v-model="selected_listen_sections"
                  :value="section.id"
                  style="margin-top: 0px !important; margin-left: 8px !important;"
                  :label="section.name"
                ></v-checkbox>
                  <v-text-field v-if="need_proj_name && section.id == session_young_id"
                    v-model="project_name"
                    outlined
                    required
                    name="input"
                    label="Название проекта"
                    class="pl-10"
                  ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirm_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="confirm_reg()">{{"Подтвердить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_reg_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите отменить регистрацию на форум?
        </v-card-title>
        <v-card-text v-if="!can_reg">
          С 01.10.2024 регистрация на форум закрыта. У вас не будет возможности зарегистрироваться заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancel_reg_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="cancel_reg()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_file_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">{{ file_type == 'thesis_file' ? 'Подгрузка тезисов' : 'Подгрузка экспертного заключения' }}
        </v-card-title>

        <v-card-text v-if="file_type == 'thesis_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx)
        </v-card-text>
        <v-card-text v-if="file_type == 'thesis_pdf'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: pdf)
        </v-card-text>
        <v-card-text v-if="file_type == 'exp_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx, pdf)
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Добавить файл"
            color="#4dbee1"
            :success="loadedFile"
            :loading="loadedFile"
            prepend-icon="mdi-paperclip">
          </v-file-input>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="upload_file_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="upload_file()">{{"Загрузить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_thesis_dialog" persistent max-width="90%">
      <thesis-upload
        :current_user_registration_id="current_user_registration_id"
        @updateParent="update_parent($event)"
        @closeDialog="close_dialog($event)"
      />
    </v-dialog>

    <v-dialog v-model="thesis_show_dialog" max-width="50%">
      <thesis-show
        :thesis_data="thesis_data"
        @closeDialog="thesis_show_dialog=false"
      />
    </v-dialog>

  </v-app>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import personalDataBase from '../components/Common/PersonalDataBase.vue'
import thesisUpload from '../components/Common/ThesisUpload.vue'
import thesisShow from '../components/Common/ThesisShow.vue'

export default {
  beforeMount() {
    this.GET_SECTIONS(this.user_meeting_id);
  },
  mounted() {
    this.uploadDataUser();
  },
  name: 'PersonalData',
  components: {
    personalDataBase,
    thesisUpload,
    thesisShow,
  },
  data: () => ({
    user_meeting_id: 1,
    end_reg_date: '2024-10-21',
    start_reg_date: '2024-07-01',
    thesis_last_date: '2024-10-21',
    // last_conf_date: '2024-08-22',
    last_conf_date: '2024-10-22',
    can_upload_thesis: false,
    can_reg: false,
    registration_dialog: false,
    reg_id: null,
    cancel_reg_dialog: false,
    confirm_reg_dialog: false,
    dialog_comment: '',
    user_registrations: [],
    user_registrations_list: [],
    upload_file_dialog: false,
    add_reg_dialog: false,
    user_type: 1,
    user_types: [
        {id: 1, name : 'Слушатель (без доклада)'},
        {id: 2, name : 'Участник с устным докладом'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    current_confirm_type: 1,
    user_types_poster: [
        {id: 1, name : 'Слушатель (без доклада)'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    section: 0,
    section_choice: 0,
    section_types: [
        {id: 0, name : 'выберите секцию:'},
        // {id: 1, name : 'секция 1: "Перспективные синхротронные и нейтронные исследования"'},
        {id: 2, name : 'сессия 1: "«Актуальные исследования и разработки, выполняемые на источниках синхротронного излучения и нейтронов, а также комплексах ядерной медицины"'},
        {id: 3, name : 'сессия 2: "Концепция и научная программа синхротронно-лазерного комплекса «СИЛА»"'},
        {id: 4, name : 'Микросимпозиум 1: "Разработка научной программы развития нейтронных исследований в Российской Федерации"'},
        {id: 5, name : 'Микросимпозиум 2: "Научная программы проектов РИФ и ТНК «Зеленоград»"'},
      ],
    loadedFile: false,
    file: null,
    checkFile: false,
    file_id: null,
    file_type: '',

    title: 'This will be the title',
    loading: false,
    model: null,
    date: new Date().toISOString().substr(0, 10),
    edit: false,
    loaded: false,
    reg_count: 0,
    can_make_sert: false,
    selected_listen_sections: [],
    active_sections: [],
    active_sections_list: {},
    need_proj_name: false,
    project_name: '',
    session_young_id: 15,
    current_user_registration_id: 0,
    upload_thesis_dialog: false,
    thesis_data: {},
    thesis_show_dialog: false,

  }),

  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },

    GETTERS_SECTIONS(val) {
      this.GETTERS_SECTIONS.forEach((item) => {
          if(item.is_active && item.is_public){
            this.active_sections.push(item)
          }
          this.active_sections_list[item.id] = item
        })
    },

    selected_listen_sections(arr){
      var find = false
      this.selected_listen_sections.forEach((item) => {
        if(item == this.session_young_id)
          find = true
      })
      this.need_proj_name = find
    },
  },

  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'GET_SECTIONS',
      'logged',
      'GET_USER_SITE_REG',
      'MAKE_REGISTRATION',
      'FILE_SEND',
      'ADD_THESIS_FILE',
      'CHANGE_REGISTRATION',
      'MAKE_INVITE',
      'MAKE_SERT',
      'DELETE_THESIS_REC',
      'LOAD_THESIS_REC',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    closeDialog(item){
      this.upload_thesis_dialog = false;
    },

    update_parent(item) {
      this.upload_thesis_dialog = false;
      if(item > 0){
        this.reload_reg_data();
      }
      // this.loadListProposals(this.status_id);
      // this.$emit('updateParent', item);
    },

    show_confirm_reg_dialog(){
      this.current_confirm_type = this.user_registrations_list[this.reg_id].confirm_type 
      this.confirm_reg_dialog = true
    },

    allowedDates(val){
      return (val > '2023-10-22' && val < '2023-10-29')
    },

    section_descr(id){
      if(!this.active_sections_list){
        setTimeout(() => {
          return this.section_descr(id)
        }, 500);

      }
      if(id > 0)
        return this.active_sections_list[id].name
      else
        return 'Не указано при регистрации!'
    },

    show_thesis(id){
      this.UPDATE_OVERLAY(true)
      this.LOAD_THESIS_REC(id)
      .then((res) => {
        this.thesis_data = res;
        this.thesis_show_dialog = true;
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });

    },

    delete_thesis(id, reg_id){
      console.log('delete_thesis', id)
      this.UPDATE_OVERLAY(true)
      let dataUpdateStatus = {
        thesis_id: id,
        reg_id: reg_id
      };

      this.DELETE_THESIS_REC(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });

    },


    upload_file() {
      this.file_id = null
      if(this.checkFile) {        
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);

        var file_type_id = 0
        if(this.file_type == 'thesis_pdf')
          file_type_id = 3
        else if (this.file_type == 'thesis_file')
          file_type_id = 4
        else if (this.file_type == 'exp_file')
          file_type_id = 5
        files.append('type', file_type_id)



        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.file_id = res.data.id
            this.save_thesis_file()
          })
          .catch(() => this.loadedFile = false)
      }
      
    },

    save_thesis_file(){
      let dataUpdateStatus = {
        id: this.reg_id,
        file_id: this.file_id,
        file_type: this.file_type
      }

      this.UPDATE_OVERLAY(true)

      this.ADD_THESIS_FILE(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.upload_file_dialog = false;
            this.reload_reg_data();
            this.$messageHelper('Успешнo', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        })
      
    },

    openFile(fileName) {
      window.open(`https://genom.kcsni-service.ru/media/${fileName}`, '_blank')
    },

    deleteFile(id,type){
      let dataUpdateStatus = {
        id: id,
        type: type
      };

      this.change_reg(dataUpdateStatus)

    },

    add_one_reg(){
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        section_choice: this.section_choice,
        one_more: true,
        selected_listen_sections: this.selected_listen_sections,
        project_name: this.project_name
      };

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.add_reg_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    registration() {
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        section_choice: this.section_choice,
        one_more: false,
        selected_listen_sections: this.selected_listen_sections,
        project_name: null
      };

      if(this.need_proj_name){
        if(this.project_name.length == 0){
          this.$messageHelper('Укажите название проекта', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }
        else{
          data.project_name = this.project_name
        }
      }

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    confirm_reg(){
        let dataUpdateStatus = {
          id: this.reg_id,
          is_confirm: true,
          type: 'confirm_reg',
          selected_listen_sections: this.selected_listen_sections,
          project_name: null
        };
        if(this.user_registrations_list[this.reg_id].confirm_type == 3 && this.current_confirm_type == 1){
          dataUpdateStatus.cancel_poster = 1
        }
        else{
          dataUpdateStatus.cancel_poster = -1
        }

        if(this.need_proj_name){
          if(this.project_name.length == 0){
            this.$messageHelper('Укажите название проекта', 'error', 3000);
            this.UPDATE_OVERLAY(false)
            return
          }
          else{
            dataUpdateStatus.project_name = this.project_name
          }
        }

        this.change_reg(dataUpdateStatus)
    },

    cancel_reg(){
        let dataUpdateStatus = {
          id: this.reg_id,
          is_active: true,
          type: 'cancel_reg'
        };

        this.change_reg(dataUpdateStatus)
    },


    change_reg(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_REGISTRATION(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.confirm_reg_dialog = false;
          this.cancel_reg_dialog = false;
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_invite(){
      this.UPDATE_OVERLAY(true)
      this.MAKE_INVITE(this.reg_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_sert(){
      this.UPDATE_OVERLAY(true)

      this.MAKE_SERT(this.reg_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    validateFile(val) {
      const type = val.name.split('.').pop();
        
      if(val.size > 6291456){
        this.$messageHelper('Размер файла превышает 6 мб', 'error')
        this.checkFile = false
        this.file = null
      }
      else{
        if (this.file_type == 'thesis_file' && type !== 'doc' && type !== 'docx'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'thesis_pdf' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'exp_file' && type !== 'doc' && type !== 'docx' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else{
          this.checkFile = true
        }
      }

    },

    reload_reg_data(){
      this.GET_USER_SITE_REG()
      .then((res) => {
        this.reg_count = res.length;
        this.selected_listen_sections = []
        if(res.length > 0){
          this.user_registrations = res
          this.user_registrations_list = []
          var ls = []
          this.project_name = res[0].project_name
          this.user_registrations.forEach((item) => {
            if(item.listen_sections !== null){
              ls = item.listen_sections.split(', ')
            }
            this.user_registrations_list[item.id] = item
          })
          ls.forEach((item) => {
            this.selected_listen_sections.push(parseInt(item))
          })
        }
        else{
          this.user_registrations = null
          this.user_registrations_list = []
        }

      })
    },

    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });

        this.reload_reg_data()
        // const site_reg = await this.GET_USER_SITE_REG();
        // this.reg_count = site_reg.length;
        // if(site_reg.length > 0){
        //   this.user_registrations = site_reg
        //   this.user_registrations_list = []
        //   this.user_registrations.forEach((item) => {
        //     this.user_registrations_list[item.id] = item
        //   })
        // }
        // else{
        //   this.user_registrations = null
        //   this.user_registrations_list = []
        // }

        var curr_date = new Date().toISOString().substr(0, 10)
        this.can_reg = curr_date < this.end_reg_date
        this.wait_reg = curr_date < this.start_reg_date
        this.can_upload_thesis = curr_date <= this.thesis_last_date
        // console.log(curr_date, this.last_conf_date)
        this.can_make_sert = curr_date >= this.last_conf_date
//!!!!!!!!!!!!!!! TODO !!!!!!!!!!!!!!
        //  this.can_reg = false
        //  this.wait_reg = false

        this.active_sections = []
        this.GETTERS_SECTIONS.forEach((item) => {
          if(item.is_active && item.is_public){
            this.active_sections.push(item)
          }
          this.active_sections_list[item.id] = item
        })

        this.loading = false;
      } catch (ex) {
        console.log('ex ---> ', ex);
      }
    },
  },

  computed: {
    ...mapGetters([
      'GETTERS_SECTIONS',
    ]),
  },
};
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
